export const getOrderPreparationStatus = order => {
	try {
		if (!order?.id) {
			return;
		}

		// const readyAt = new Date(order.createdAt).getTime() + (order.delayMinutes || 0) * 60 * 1000;

		// const preparationStatus = Date.now() > readyAt ? "is-ready" : "not-ready";
		const preparationStatus = Date.now() > order.readyAt ? 'is-ready' : 'not-ready';

		// console.log(preparationStatus);
		return {
			preparationStatus,
		};
	} catch (error) {
		console.log('getOrderPreparationStatus err:', error);
	}
};
